<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-date ttLabel="systemdate" [(ttModel)]="edit.systemdate" ttRequired></tt-date>
        <tt-select ttLabel="country" [(ttModel)]="edit.country_id" [ttData]="selectListCountries" ttDataId="country_id" ttDataName="country_name"></tt-select>
        <tt-input ttLabel="holyday_name" [(ttModel)]="edit.holyday_name" ttRequired></tt-input>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button *ngIf="p2HoliDayKeyno !== '0'" ttText="delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
    </tt-card>
</tt-page>
